// The Teacher Loop's build flag and public paths, with no imports: App and the
// always-loaded shell import only this, so a flag-off build carries none of
// the feature's code in its main bundle (the pages and dialogs are lazy).
//
// Code that ships to everyone (App, the header pill, the plan popup, the
// feedback page) tests the flag as the literal
// `process.env.REACT_APP_TEACHER_LOOP === 'on'` (the same test as
// isTeacherLoopEnabled()) and puts every Teacher Loop import() behind it:
// Parcel inlines the variable at build time, folds the test to false in a
// flag-off build and drops the guarded code, the import and its chunk. A call
// to isTeacherLoopEnabled() from another module can't be folded that way.

export const isTeacherLoopEnabled = () =>
  process.env.REACT_APP_TEACHER_LOOP === 'on';

/**
 * What a flag-guarded React.lazy loads when the flag is off (never rendered
 * then; it keeps the loader a valid module promise):
 *   React.lazy(() => process.env.REACT_APP_TEACHER_LOOP === 'on'
 *     ? import('./X') : noTeacherLoopModule())
 */
const Nothing = () => null;
export const noTeacherLoopModule = () => Promise.resolve({ default: Nothing });

export const TEACHER_CHECK_PATH = '/check/';

// The gift pages (/thanks/<code>, /gift/verify).
export const GIFT_PUBLIC_PATHS = ['/thanks/', '/gift/verify'];

/**
 * Paths the app serves without a login, added to App.jsx publicPaths: the
 * Teacher Check pages and the gift card / its confirmation link.
 */
export const teacherLoopPublicPaths = () =>
  isTeacherLoopEnabled() ? [TEACHER_CHECK_PATH, ...GIFT_PUBLIC_PATHS] : [];

/** The shared-link page and the Teacher Check page: logged-out renderers. */
export const isPublicFeedbackPath = (pathname) => {
  const path = String(pathname || '');
  return (
    path.startsWith('/view/submissions/') || path.startsWith(TEACHER_CHECK_PATH)
  );
};

/**
 * Teacher Loop pages that stand on their own (no MainSidebar, their own
 * header), with the build flag on: /check/… and the gift pages.
 */
export const isTeacherLoopStandalonePath = (pathname) =>
  isTeacherLoopEnabled() &&
  [TEACHER_CHECK_PATH, ...GIFT_PUBLIC_PATHS].some((prefix) =>
    String(pathname || '').startsWith(prefix)
  );
